import React from "react";
import { OnboardingSlide } from "core/models/OnboardingSlide";
import Onboarding from "ui/components/molecules/Onboarding";
import useOnboarding from "ui/hooks/useOnboarding";

const onboardingSlides: OnboardingSlide[] = [
    {
        id: 0,
        image: "./static/img/onboarding-create-clips.png",
        title: "Connect your live stream",
        body: (
            <div>
                Here you can view all your incoming live streams and select
                which one to cut videos from. Start by connecting your first
                live stream, by pressing &#39;Connect live stream&#39;. We
                support RTMP push and HLS Pull. Or use our demo stream for a
                quick test. You can always get in touch if you need help getting
                started or require something different from what is mentioned.
            </div>
        ),
        contactUs: true,
        buttonText: "Next",
    },
];

const ChannelsOnboarding: React.FC = () => {
    const { completed, onCompleted } = useOnboarding("channelsOnboarding");
    if (completed || completed === undefined) {
        return null;
    }
    return <Onboarding slides={onboardingSlides} onComplete={onCompleted} />;
};
export default React.memo(ChannelsOnboarding);
